module.exports = __webpack_public_path__ + "img/diagnostico@2x.49835dbf.jpeg";